export interface ISupportDataSsp {
	emailFrom: string
	subject: string
	body: string
	countryCode: string
	productType: ProductType
}

export interface ISupportCashToCard {
	subject: string
	partyId: string
	agreementId: string
	ibanDE: string
	amount: number
	termsAndConditions: boolean
}

export enum ProductType {
	Card = 'Card',
	Deposit = 'Deposit',
	Deposit_Fixed = 'Deposit_Fixed',
}

export interface IMaintenance {
	maintenanceWindowFrom: string
	maintenanceWindowTo: string
	preMessageDE: string
	preMessageAT: string
	preMessageEN: string
	preMessageNO: string
	preMessageDK: string
	preMessageSE: string
	preMessageFI: string
	preMessageEE: string
	preMessageES: string
	durationMessageDE: string
	durationMessageAT: string
	durationMessageEN: string
	durationMessageNO: string
	durationMessageDK: string
	durationMessageSE: string
	durationMessageFI: string
	durationMessageEE: string
	durationMessageES: string
	minutesBeforeMaintenance: number
	affectedSystems: string[]
	affectedMarkets: string[]
}
